/*───────────────────────────────────────────────────────────────
 📄 File: components/webrtc/WebRTCDialScreen.tsx
 🧩 Description:
    Idle/dial screen: number input, dial pad and call button.
    Extracted from WebRTCPhonePanel.tsx.
────────────────────────────────────────────────────────────────*/

import { Phone, Delete } from 'lucide-react';

const DIAL_PAD = [['1','2','3'],['4','5','6'],['7','8','9'],['*','0','#']];

interface Props {
    dialNumber: string;
    status: string;
    onDialNumberChange: (v: string) => void;
    onDigitClick: (d: string) => void;
    onBackspace: () => void;
    onCall: () => void;
}

export function WebRTCDialScreen({ dialNumber, status, onDialNumberChange, onDigitClick, onBackspace, onCall }: Props) {
    return (
        <>
            {/* Number Input */}
            <div className="bg-muted/50 rounded-lg p-3 mb-3">
                <div className="relative">
                    <input
                        type="tel"
                        value={dialNumber}
                        onChange={(e) => onDialNumberChange(e.target.value)}
                        onKeyDown={(e) => { if (e.key === 'Enter' && dialNumber && status === 'registered') { e.preventDefault(); onCall(); } }}
                        placeholder="Enter number"
                        className="w-full bg-transparent text-xl font-medium text-foreground placeholder-muted-foreground focus:outline-none pr-10 text-center"
                    />
                    {dialNumber && (
                        <button onClick={onBackspace} className="absolute right-0 top-1/2 -translate-y-1/2 p-1.5 hover:bg-muted rounded text-muted-foreground">
                            <Delete className="w-4 h-4" />
                        </button>
                    )}
                </div>
            </div>

            {/* Dial Pad */}
            <div className="grid grid-cols-3 gap-1.5 mb-3">
                {DIAL_PAD.map((row, ri) => row.map((digit, ci) => (
                    <button key={`${ri}-${ci}`} onClick={() => onDigitClick(digit)} className="py-3 text-lg font-medium bg-muted/50 hover:bg-muted text-foreground rounded-lg transition-colors">
                        {digit}
                    </button>
                )))}
            </div>

            {/* Call Button */}
            <button onClick={onCall} disabled={!dialNumber || status !== 'registered'} className="w-full py-3 bg-green-600 hover:bg-green-700 disabled:bg-muted disabled:opacity-50 disabled:cursor-not-allowed text-white rounded-lg transition-colors flex items-center justify-center gap-2 font-medium">
                <Phone className="w-5 h-5" /> Call
            </button>
        </>
    );
}
